import { axiosInstance } from ".";

const getCategoriesList = async (params) =>
  await axiosInstance.get("/categories", { params });

const addCategory = async (payload) =>
  await axiosInstance.post("/categories", payload);

const getCategoryDetails = async (id) =>
  await axiosInstance.get(`/categories/${id}`);

const editCategory = async ({ id, data }) =>
  await axiosInstance.put(`/categories/${id}`, data);

// PATCH is_multi_session_allowed for a category
const patchCategoryToggle = async ({ id, is_multi_session_allowed }) =>
  await axiosInstance.patch(`/categories/${id}`, {
    is_multi_session_allowed,
  });

const deleteCategory = async ({ id }) =>
  await axiosInstance.delete(`/categories/${id}`);

export {
  getCategoriesList,
  addCategory,
  getCategoryDetails,
  editCategory,
  patchCategoryToggle,
  deleteCategory,
};
